import { render, staticRenderFns } from "./ContactInfoList.vue?vue&type=template&id=83fe33f2"
import script from "./ContactInfoList.vue?vue&type=script&lang=js"
export * from "./ContactInfoList.vue?vue&type=script&lang=js"
import style0 from "./ContactInfoList.vue?vue&type=style&index=0&id=83fe33f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports